import type {RouteRecordRaw} from 'vue-router';
import type {CommonRouteMeta} from '@/types/common';

const BaseDashboard = () => import('@/views/dashboard/BaseDashboard.vue');
const ConversionAnalytics = () => import('@/views/dashboard/analytics/Conversion/ConversionAnalytics.vue');
const VehicleAnalytics = () => import('@/views/dashboard/analytics/Vehicle/VehicleAnalytics.vue');

const analyticsRoutes: RouteRecordRaw = {
    path: '/analytics',
    component: BaseDashboard,
    redirect: {name: 'analytics.vehicle'},
    meta: {
        title: 'analytics',
        icon: 'mdi-poll',
        noCache: false,
        middleware: ['auth'],
        isBase: true,
        layout: 'Dashboard',
        permissions: ['listings_view'],
        showInMenu: true,
    } as CommonRouteMeta,
    children: [
        {
            path: 'vehicle',
            component: VehicleAnalytics,
            name: 'analytics.vehicle',
            meta: {title: 'Fleet Performance', icon: 'mdi-poll', noCache: false, isBase: true},
        },
        {
            path: 'conversion',
            component: ConversionAnalytics,
            name: 'analytics.conversion',
            meta: {
                title: 'Conversion Analytics',
                icon: 'mdi-poll',
                noCache: false,
                isBase: true,
                helpArticle: 'https://help.fleetwire.io/en/article/enable-e-commerce-tracking-in-fleetwire-11iijjl/',
            },
        },
    ],
};

export default analyticsRoutes;
